export default __webpack_public_path__ + "static/media/talon-vikailmoitus.191511f5.svg";